import { render, staticRenderFns } from "./HistorySearch.vue?vue&type=template&id=fb76135a&"
import script from "./HistorySearch.vue?vue&type=script&lang=js&"
export * from "./HistorySearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports